import { Component } from '@angular/core';

@Component({
  selector: 'app-seup-subjekt',
  templateUrl: './seup-subjekt.component.html'
})
export class SeupSubjektComponent {}
